module.exports = __webpack_public_path__ + "img/Vaisselle_jetable.7d9d3b7.jpg";